import { render, staticRenderFns } from "./ActivateDeactivatePartnerDialog.vue?vue&type=template&id=9afba946"
import script from "./ActivateDeactivatePartnerDialog.vue?vue&type=script&lang=js"
export * from "./ActivateDeactivatePartnerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports